import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CaretDown, MagnifyingGlass } from '@phosphor-icons/react';
import { NAV_HEADLINES, ALL_KEYWORDS } from '../data/navLinks';
import { MARKET_GROUPS } from './MarketsMenu';

const byPrefix = (prefix) => Object.entries(NAV_HEADLINES).filter(([p]) => p.startsWith(prefix)).map(([path, v]) => ({ path, ...v }));
const COLUMNS = [
  { heading: 'Specialty Services', links: MARKET_GROUPS[1].links },
  { heading: 'Global Markets', links: MARKET_GROUPS[0].links },
  { heading: 'Canada Cities', links: byPrefix('/canada/') },
  { heading: 'UK Cities', links: byPrefix('/uk/') },
  { heading: 'Australia Cities', links: byPrefix('/australia/') },
];
const TABS = [['usa', 'USA'], ['canada', 'Canada'], ['uk', 'UK'], ['australia', 'Australia']];
const tid = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const Collapse = ({ open, children, testid }) => (
  <div className={`grid transition-[grid-template-rows,opacity] duration-300 ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-testid={testid} aria-hidden={!open}>
    <div className="overflow-hidden">{children}</div>
  </div>
);

const AllKeywords = () => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState('usa');
  return (
    <div className="border-t border-white/10 mt-8 pt-6">
      <button onClick={() => setOpen(o => !o)} className="flex items-center gap-2 text-sm font-semibold text-white" data-testid="all-keywords-toggle" aria-expanded={open}>
        <MagnifyingGlass size={16} /> All Keywords <CaretDown size={12} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <Collapse open={open} testid="all-keywords-panel">
        <div className="flex gap-2 mt-4 mb-4">
          {TABS.map(([k, label]) => (
            <button key={k} onClick={() => setTab(k)} className={`px-3 py-1.5 rounded text-xs font-semibold ${tab === k ? 'bg-[#06D6E0] text-[#0A0A23]' : 'bg-white/10 text-zinc-300'}`} data-testid={`keywords-tab-${k}`}>{label}</button>
          ))}
        </div>
        {TABS.map(([k]) => (
          <div key={k} className={`grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2 ${tab === k ? '' : 'hidden'}`} data-testid={`keywords-list-${k}`}>
            {ALL_KEYWORDS[k].map(x => (
              <Link key={x.kw} to={x.path} className="group block py-1">
                <span className="block text-sm text-white group-hover:text-[#06D6E0]">{x.kw}</span>
                <span className="block text-[11px] text-zinc-500 leading-snug">{x.headline}</span>
              </Link>
            ))}
          </div>
        ))}
      </Collapse>
    </div>
  );
};

export const FooterExplore = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-white/10 bg-[#0D0D2B]" data-testid="footer-explore">
      <div className="container-custom py-5">
        <button onClick={() => setOpen(o => !o)} className="w-full flex items-center justify-between text-left" data-testid="footer-explore-toggle" aria-expanded={open}>
          <span>
            <span className="block font-bold text-white" style={{ fontFamily: 'Outfit' }}>Explore All Services & Locations</span>
            <span className="block text-xs text-zinc-400 mt-0.5">Survey CAD drafting services, specialty pages and local coverage across the USA, Canada, UK and Australia.</span>
          </span>
          <CaretDown size={18} className={`text-zinc-400 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        <Collapse open={open} testid="footer-explore-panel">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8 pt-8">
            {COLUMNS.map(c => (
              <div key={c.heading}>
                <p className="text-[10px] font-bold uppercase tracking-wider text-[#06D6E0] mb-3">{c.heading}</p>
                {c.links.map(l => (
                  <Link key={l.path} to={l.path} className="group block py-1.5" data-testid={`footer-explore-link-${tid(l.name)}`}>
                    <span className="block text-sm text-white group-hover:text-[#06D6E0]">{l.name}</span>
                    <span className="block text-[11px] text-zinc-500 leading-snug">{l.headline}</span>
                  </Link>
                ))}
              </div>
            ))}
          </div>
          <AllKeywords />
        </Collapse>
      </div>
    </div>
  );
};
